'use client'

import {ErrorBoundary} from '@/app/components/ErrorPage/ErrorPage'
export default ErrorBoundary
